<script setup lang="ts">
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { authenticate } from '@/services/api/auth'

const router = useRouter()

const authenticating = ref(false)
const error = ref(false)

const formState = reactive({
  login: '',
  password: '',
})

const login = async () => {
  //const isFormCorrect = await v$.value.$validate()
  //if (!isFormCorrect) return

  try {
    authenticating.value = true
    await authenticate(formState.login, formState.password)

    router.push('/')
  } catch (e) {
    console.error(e.message)

    authenticating.value = false
    error.value = true
  }
}
</script>

<template>
  <div class="page login">
    <header>
      <img class="illustration" src="./assets/illustration.svg" alt="Illustration" />
      <img class="logo" src="@/assets/images/header-logo.svg" alt="Logo OPALA" />
    </header>
    <div class="error">
      <SuiMessage error v-show="error">Identifiants incorrects</SuiMessage>
    </div>
    <SuiForm class="form" @submit.prevent="login">
      <fieldset>
        <div class="field">
          <label>E-mail</label>
          <SuiInput icon="mdi mdi-account-box" v-model="formState.login" />
        </div>
        <div class="field">
          <label>Mot de passe</label>
          <SuiInput
            class="input"
            icon="mdi mdi-lock"
            type="password"
            v-model="formState.password"
          />
          <a class="forgot-password" href="https://preprod-opala.challancin.fr/"
            >J'ai oublié mon mot de passe</a
          >
        </div>
      </fieldset>
      <SuiButton class="button" type="submit" :loading="authenticating">Se connecter</SuiButton>
    </SuiForm>
  </div>
</template>

<style scoped lang="scss">
$borderGrey: #e0e2ed;
$yellow: #ffbd00;

.login {
  header {
    height: 35dvh;
    padding: 4dvh 0;
    background: no-repeat top 0 left 0 url('@/assets/images/header-background.svg');
    background-size: 100% auto;

    img {
      display: block;
      margin: 0 auto;
      &.illustration {
        height: 75%;
      }
      &.logo {
        width: 65%;
        margin-top: 2.5dvh;
      }
    }
  }

  .error {
    height: 10dvh;
    padding: 0 5%;
    display: flex;
    align-items: flex-end;

    &:deep(.ui.message) {
      font-weight: 500;
      font-size: 16px;
      padding: 0;
      background-color: transparent;
      box-shadow: none;
    }
  }

  .form {
    height: 50dvh;
    padding: 2.5dvh 5%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    fieldset {
      padding: 0;
      border: none;
    }

    .field {
      margin-top: 2dvh;
      margin-bottom: 4dvh;

      &:last-child {
        margin-bottom: 0;
      }

      &.error input {
        background-color: transparent;
      }

      label {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        text-transform: uppercase;
        color: var(--primary-color) !important;
      }

      .input:deep(input) {
        border: none;
        border-radius: 0;
        border-bottom: 1px solid $borderGrey;
        font-size: 16px;
        padding-left: 0;

        color: #344c60;

        /* Disable webkit autofill style */
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus {
          background-color: white !important;
          border: none !important;
          border-bottom: 1px solid $borderGrey !important;
          box-shadow: 0 0 0 100px white inset !important;
        }

        &:focus {
          border-bottom: 1px solid $yellow;
        }
      }

      .input:deep(i.icon) {
        color: $borderGrey;
      }

      .input:deep(i.mdi) {
        border-right: none;
        opacity: 1;
        font-size: 20px;
      }

      .forgot-password {
        display: block;
        font-size: 16px;
        margin-top: 18px;
        color: $yellow;
      }
    }

    .button {
      margin: 3dvh auto;
      padding: 15px 30px;
      border-radius: 10px;
      text-transform: uppercase;
    }
  }
}
</style>
